const BulbIcon = ({ size = 24, color = 'currentColor', className = '' }) => (
  <svg aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    className={className}
  >
    <path d="M9 18h6M10 22h4M8.5 14.5A6 6 0 1 1 15.5 14.5C14.7 15.2 14 16.2 14 17.3V18h-4v-.7c0-1.1-.7-2.1-1.5-2.8Z" />
  </svg>
);

export default BulbIcon;
